<template>
  <div>
    <h1 class="title is-3 table-padding-fix">Aantal gebruikers: {{users.length}}</h1>
    <div class="columns">
      <div class="column is-8">
        <table class="table is-striped">
          <thead>
            <tr>
              <th>Voornaam</th>
              <th>Achernaam</th>
              <th>Email</th>
              <th>Aangemaakt op</th>
              <th v-permission="'owner'"><!-- Edit user column --></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users">
              <td>{{user.firstName}}</td>
              <td>{{user.lastName}}</td>
              <td><a v-bind:href="`mailto:${user.email}`">{{user.email}}</a></td>
              <td>{{user.createdAt | timezone | date}}</td>
              <td v-permission="'owner'"><router-link :to="{ name: 'settings.edit.user', params: { id: user.id } }" class="button is-primary">Bewerken</router-link></td>
            </tr>
          </tbody>
        </table>

        <router-link :to="{ name: 'settings.new.user' }" class="button is-primary" v-permission="'owner'">Gebruiker aanmaken</router-link>
      </div>
      <div class="column">
        <div class="content notification is-primary has-white-text spacing-top-40">
          <h2>Nieuwe gebruiker</h2>
          <p>Om een nieuwe gebruiker aan te maken moet u contact opnemen met de IT beheerder.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      users: 'users'
    })
  },
  async created () {
    try {
      await this.$store.dispatch('getAllUsers')
    } catch (error) {
      this.$snackbar.open({
        type: 'is-danger',
        message: 'Er ging iets fout tijdens het ophalen van de gebruikers.'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/users/index.vue